<template>
  <v-app-bar app clipped-left elevation="1" :prominent="makeProminent" :color="$route.meta.headerColor? $route.meta.headerColor: 'blue lighten-1'">
    <h1>{{$route.meta.pageTitle}}</h1>
    <v-spacer />

    <v-menu offset-y v-if="userName">
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip left>
          <template v-slot:activator="{ on: tooltip }">
            <v-avatar color="orange darken-3" size="48" v-bind="attrs" v-on="{ ...tooltip, ...menu }">
              <span class="white--text headline">{{ firstChar }}</span>
            </v-avatar>
          </template>
          <span>{{ userName }}</span>
        </v-tooltip>
      </template>
      <v-list dense>
        <v-list-item dense v-if="role == 'admin'">
          <v-list-item-title>
            <v-icon left>mdi-dots-grid</v-icon>
            <a href="/admin">{{ $t("common.actions.mainAdministration") }}</a>
          </v-list-item-title>
        </v-list-item>
        <v-list-item dense>
          <v-list-item-title>
            <v-icon left>mdi-logout</v-icon>
            <a href="/logout">{{ $t("common.actions.logout") }}</a>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <template v-slot:extension v-if="hasSlotData">
      <slot />
    </template>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    drawer: null,
  }),

  props: {},

  computed: {
    ...mapGetters(["isLoggedIn", "userName", "role"]),
    makeProminent: function() {
      return this.$route.meta.prominentHeader || false;
    },
    hasSlotData: function() {
      return this.$slots.default;
    },
    firstChar: function() {
      return this.userName ? this.userName.substring(0, 1).toUpperCase() : "";
    },
  },

  methods: {},

  components: {},
};
</script>

<style></style>
